import React, { memo } from 'react'
import List, { ListProps } from '../List/List'
import styles from './Select.module.sass'
import clsx from 'clsx'
import CheckIcon from 'files/check.svg'
import { Checkbox } from '../../../controls/Checkbox/Checkbox'
import { Colors } from '../../../../styles'
import SUPIcon from 'files/sup.svg'
import FPIcon from 'files/fp.svg'

export interface SelectProps<T> extends ListProps<T>{
    selected: readonly T[],
    multi?: boolean,
    header?: boolean
}

const Select = <T extends unknown>(props: SelectProps<T>): JSX.Element => {
    const keys = props.selected.map(props.toKey)
    return <List<T>
        className={clsx(styles.select, props.className)}
        data={props.data}
        toKey={props.toKey}
        onClick={props.onClick}
        toClassName={props.toClassName}
        render={item => {
            let isDesign
            for(const prop in item) {
                if(prop === 'is_design') isDesign = item[prop]
            }
            return <>
            <div className={styles.check}>
                {
                    !props.multi ?
                        (keys.includes(props.toKey(item)) && <CheckIcon/>) :
                        <Checkbox
                            color={Colors.grey}
                            value={keys.includes(props.toKey(item))}
                        />
                }
            </div>
            <div className={styles.content}>
                <div className={styles.projectIconWrapper}>
                    {

                        props.header !== true && typeof isDesign === 'number' ?
                            isDesign === 0 ? <FPIcon className={styles.projectIcon} /> : <SUPIcon  className={styles.projectIcon} /> :
                            ''
                    }
                    {
                        props.render(item)
                    }
                </div>
            </div>
        </>}}
    />
}

export default memo(Select) as typeof Select